// Text + geometric SVG placeholders. Swap the SVG marks for real logo files later.

export const IncepticaMark = ({ size = 26, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    className={className}
  >
    <rect x="1" y="1" width="30" height="30" rx="9" stroke="url(#ig)" strokeWidth="1.6" />
    <path d="M16 8 L23 16 L16 24 L9 16 Z" fill="url(#ig)" fillOpacity="0.92" />
    <circle cx="16" cy="16" r="3" fill="#fff" />
    <defs>
      <linearGradient id="ig" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
        <stop stopColor="#18181b" />
        <stop offset="1" stopColor="#2563eb" />
      </linearGradient>
    </defs>
  </svg>
);

export const IncepticaLogo = ({ className = "h-10" }) => (
  <img
    src="/inceptica-logo.png"
    alt="Inceptica"
    data-testid="inceptica-logo"
    className={`w-auto ${className}`}
  />
);

export const NovaLogo = ({ className = "", size = 40, tone = "light" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="nova-logo">
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <rect width="40" height="40" rx="12" fill="url(#ng)" />
      <path
        d="M12 28 V12 L28 28 V12"
        stroke="#fff"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <defs>
        <linearGradient id="ng" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2563EB" />
          <stop offset="1" stopColor="#1e3a8a" />
        </linearGradient>
      </defs>
    </svg>
    <span
      className={`font-display text-2xl font-semibold tracking-tight ${
        tone === "dark" ? "text-zinc-900" : "text-white"
      }`}
    >
      Nova
    </span>
  </div>
);
